import React from 'react';
import { BugReportOutlined } from '@mui/icons-material';
import { useSession } from '@hooks';

type BugReportProps = {}

const BugReport: React.FC<BugReportProps> = ({ }) => {
  const { sessionId } = useSession()
  return <div className={"tw-sticky tw-bottom-4 tw-left-4 tw-inline-block tw-transition-colors tw-duration-200 tw-ease-in-out"}>
    <a href={`mailto:webteam@resalys.com?cc=guillaume.blanc@sequoiasoft.com
      &subject=${process.env.REACT_APP_CUSTOMER_NAME}%20Recette%20Neobooking%20Bugreport%20-%20Session%20:%20${sessionId}
      &body=Instruction%20de%20bug%20:%0D%0A
      Pour%20remonter%20votre%20bug,%20merci%20d'indiquer%20le%20bloc%20qui%20pose%20probleme%20et%20le%20bug%20de%20la%20facon%20la%20plus%20précise.%0D%0APour%20faciliter%20la%20résolution,%20nous%20vous%20invitons%20à%20ajouter%20une%20image%20ou%20une%20capture%20d'écran%20(de%20toute%20la%20page)%20si%20vous%20le%20pouvez.%0D%0ADans%20le%20cas%20contraire%20ne%20pas%20oublier%20de%20préciser%20les%20éléments%20de%20reproduction,%20comme%20la%20date%20de%20séjour%20la%20composition%20du%20séjour%20ou%20l'établissement%20et%20la%20typologie.%0D%0A
      %0DRapport%20de%20bug%20:%0D%0D`}>
      <BugReportOutlined fontSize="medium" className='tw-block tw-h-6 tw-w-6 hover:tw-text-primary-500 tw-transition-colors tw-duration-200 tw-ease-in-out' aria-hidden="true" />
    </a>
  </div>
}

export default BugReport